import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { IMG_LOGO } from 'images';
import './topBar.scss';

const TopBar = () => {
  return (
    <div className="sr-topbar">
      <Grid container>
        <Grid item xs={12}>
          <Box className="sr-topbar-container">
            <img
              src={IMG_LOGO}
              alt="SenseLoaf"
              className="sr-topbar-container-logo"
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default TopBar;
